// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"689df629","389":"889468bd","455":"5b8455bb","977":"05a77e01"}[chunkId] + ".chunk.js";
};